import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately
    window.scrollTo(0, 0);

    // Also scroll after a small delay to handle any animations/transitions
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  // Also scroll to top on initial mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}
